var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createElement, memo, useCallback, useEffect, useRef } from '@max/max';
import './index.scss';
import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
import TeamRanking from './components/team-ranking';
import { hotelTheme } from '@max/leez-theme-hotel';
import { setCustomTheme } from '@max/leez-context';
import { useShare } from "./hooks/useShare/useShare.web";
import { InviteType } from './types/shared';
import View from '@hfe/max-view';
import { useTeamRanking } from './hooks/useTeamRanking';
import { useInvitePopup } from './hooks/useInvitePopup';
import { BID_MAP, FREE_CARD_VAP, INVITE_CALL_VAP, INVITE_REWARD_VAP, ORDER_URL_IN_MT as gotoOrderUrlInMt, ORDER_URL_IN_WX as gotoOrderUrlInWX } from './const';
import { preloadVap } from './utils/vap-preload/index.web';
import Sensor from '@max/mbc-sensor';
import { TechStackUtil } from '@nibfe/mkt-common-utils';
import LImage from '@max/leez-image';
import { AssistStatus } from './types/teamRanking';
import { useTasksPopup } from './hooks/useTasksPopup';
import { useDraw } from './hooks/useDraw';
import { useRecommendPoi } from './hooks/useRecommendPoi';
import DrawModule from './components/draw-module';
// import { getUserInfo, login } from '@nibfe/mkt-user-api'
import { usePredictCityInfo } from './hooks/usePredictCityInfo';
setCustomTheme(hotelTheme);
preloadVap(INVITE_CALL_VAP);
preloadVap(FREE_CARD_VAP);
preloadVap(INVITE_REWARD_VAP);
const TeamRankingFree = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    props = Object.assign(Object.assign({}, props), { teamRankingId: props.idConfigs.teamRankingId, inviteCallTaskId: props.idConfigs.inviteCallTaskId, inviteMemberTaskId: props.idConfigs.inviteMemberTaskId, inviteUnlockFreeCardTaskId: props.idConfigs.inviteUnlockFreeCardTaskId, drawTaskId: props.idConfigs.drawTaskId });
    const ctx = useMonitorEngineContext();
    const { userId, cityInfo } = ctx._runtimeInfo.commonParams || {};
    const { cityId, locCityId } = cityInfo || {};
    const { inviter } = ((_a = ctx._runtimeInfo) === null || _a === void 0 ? void 0 : _a.queryParams) || {};
    // const {inviter} = {
    //   inviter: 906698074,
    //   inviteType: InviteType.INVITE_CALL,
    //   invite_source: 'share',
    //   groupId: 23283764,
    // };
    const { shareWXCard } = useShare(props.operationOptions.shareType);
    const teamRankingAnchorRef = useRef(null);
    const teamRankingAnchorKey = `teamRanking_${ctx._moduleId}`;
    const teamRankingStates = useTeamRanking({
        activityId: props.activityId,
        teamRankingId: props.teamRankingId,
        usePushAssist: props.operationOptions.usePushAssist,
        disableNoticePopup: props.operationOptions.disableNoticePopup,
        rankingListTime: props.operationOptions.rankingListTime,
        feConfig: props
    });
    const invitePopupStates = useInvitePopup({
        activityId: props.activityId,
        inviteCallTaskId: props.inviteCallTaskId,
        inviteUnlockFreeCardTaskId: props.inviteUnlockFreeCardTaskId
    });
    const tasksPopupStates = useTasksPopup({
        activityId: props.activityId,
        // cityOrderTaskId: props.cityOrderConfig.taskId,
        taskIds: ((_b = props.tasksConfig) === null || _b === void 0 ? void 0 : _b.map(item => item.taskId)) || []
    });
    const drawStates = useDraw({
        activityId: props.activityId,
        taskId: props.drawTaskId || 0
    });
    const { recommendPoiData, loadRecommendPoi, browseRecommendedHotelPoi } = useRecommendPoi({
        wxLaunchPoiDetailUrlSchema: ((_c = props.rdConfig) === null || _c === void 0 ? void 0 : _c.wxLaunchPoiDetailUrlSchema) || ''
    });
    const { predictCityInfoData, loadPredictCityInfoData } = usePredictCityInfo({
        cityId: cityId,
        locateCityId: locCityId
    });
    const lxReport = useCallback((bid, extraVal) => {
        var _a;
        try {
            const { isFromShare, hotelchannel = '-999', rewardId, inviter, inviteType, invite_source, leaderId } = ((_a = ctx._runtimeInfo) === null || _a === void 0 ? void 0 : _a.queryParams) || {};
            const lxCommonParams = {
                activity_id: props.activityId,
                is_from_share: isFromShare === 'true',
                hotel_channel: hotelchannel,
                reward_id: rewardId,
                inviter: Number.isNaN(Number(inviter)) ? '-999' : inviter,
                leader_id: Number.isNaN(Number(leaderId)) ? '-999' : leaderId,
                invite_type: inviteType,
                invite_source
            };
            const valLab = extraVal ? Object.assign(Object.assign({}, lxCommonParams), extraVal) : lxCommonParams;
            switch (bid) {
                // mv
                case BID_MAP.COMP_MV:
                case BID_MAP.TEAM_CREATE_MV:
                case BID_MAP.TEAM_JOIN_MV:
                case BID_MAP.POINTS_EXCHANGE_MV:
                case BID_MAP.GO_TO_ORDER_MV:
                case BID_MAP.TASK_POPUP_MV:
                case BID_MAP.INVITE_POPUP_MV:
                case BID_MAP.RED_NOTE_TASK_MV:
                case BID_MAP.RED_NOTE_AUDIT_MV:
                case BID_MAP.RED_NOTE_SHARE_MV:
                case BID_MAP.DRAW_MODULE_MV:
                    ctx._LXReport.mvReport(bid, {
                        valLab
                    });
                    break;
                // mc & 非跳转
                case BID_MAP.TEAM_CREATE_MC:
                case BID_MAP.TEAM_JOIN_MC:
                case BID_MAP.SHARE_MC:
                case BID_MAP.POINTS_EXCHANGE_MC:
                case BID_MAP.POKE_BTN_MC:
                case BID_MAP.REWORDS_TAB_MC:
                case BID_MAP.RANKING_LIST_MC:
                case BID_MAP.REWARD_LIST_MC:
                case BID_MAP.RED_NOTE_AUDIT_MC:
                case BID_MAP.RED_NOTE_SHARE_MC:
                case BID_MAP.DRAW_MODULE_MC:
                    ctx._LXReport.mcReport(bid, {
                        valLab
                    });
                    break;
                // mc & 跳转
                case BID_MAP.GO_TO_ORDER_MC:
                case BID_MAP.TASK_BROWSE_MC:
                case BID_MAP.TASK_ORDER_MC:
                    ctx._LXReport.mcReportWithTag(bid, {
                        valLab
                    });
                    break;
                default:
                    let unused = bid;
                    break;
            }
        }
        catch (e) {
            ctx._raptorReport.reportLog('上报埋点异常', e, {
                category: 'jsError',
                level: 'warn',
                tags: {
                    bid
                }
            });
        }
    }, [ctx, props.activityId]);
    const onTeamRankingAnchorLayout = (e) => {
        var _a, _b, _c, _d;
        if (!teamRankingAnchorRef.current)
            return;
        const topY = ((_b = (_a = e === null || e === void 0 ? void 0 : e.nativeEvent) === null || _a === void 0 ? void 0 : _a.layout) === null || _b === void 0 ? void 0 : _b.y) || 10;
        (_d = (_c = ctx === null || ctx === void 0 ? void 0 : ctx._uiInteractionAPI) === null || _c === void 0 ? void 0 : _c.anchor) === null || _d === void 0 ? void 0 : _d.addAnchor(teamRankingAnchorKey, ctx._moduleId, {
            ref: teamRankingAnchorRef,
            anchorRelativeRootModulePositionY: topY
        });
    };
    const initRequest = () => __awaiter(void 0, void 0, void 0, function* () {
        // 先创建活动实例，再请求主接口（并行请求抽奖接口），两者无数据依赖关系，但后端有顺序依赖关系
        try {
            yield teamRankingStates.joinActivity();
            // TODO: mock 模式下强制加载，联调完毕后改回 if (props.drawTaskId)
            drawStates.loadDrawInfo();
            yield teamRankingStates.fetchTeamRankingData();
            if (Number(inviter)) {
                tasksPopupStates.loadTasksData({
                    leaderId: Number(inviter)
                });
                invitePopupStates.requestInvite();
                loadRecommendPoi();
                loadPredictCityInfoData();
            }
        }
        catch (error) {
            console.log(error);
        }
    });
    useEffect(() => {
        // 客态用户非首次进入打call
        if (invitePopupStates.assistStatus === AssistStatus.FAILED) {
            tasksPopupStates.setTaskPopupVisible(true);
            // invitePopupStates.setInvitePopupVisible(true)
        }
    }, [invitePopupStates.assistStatus]);
    useEffect(() => {
        initRequest();
    }, []);
    useEffect(() => {
        var _a;
        console.log('teamRankingFreeInfo emit');
        (_a = ctx === null || ctx === void 0 ? void 0 : ctx._communication) === null || _a === void 0 ? void 0 : _a.emit('teamRankingFreeInfo', {
            activityId: props.activityId,
            inTeam: teamRankingStates.inTeam,
            teamInfo: teamRankingStates.teamInfo,
            shareConfig: Object.assign(Object.assign({}, props.shareConfig), { shareUrl: props.shareUrl, shareType: props.operationOptions.shareType }),
            freeCardDesc: props.textConfig.freeCardDesc,
            wishOptions: props.isIncludeWishTask ? props.wishOptions : [],
            anchorKey: teamRankingAnchorKey
        });
    }, [props.activityId, teamRankingStates.inTeam, props.shareConfig, props.shareUrl, teamRankingStates.teamInfo, props.textConfig, props.wishOptions, props.isIncludeWishTask]);
    useEffect(() => {
        var _a;
        (_a = ctx._communication) === null || _a === void 0 ? void 0 : _a.on('teamRankingRefresh', teamRankingStates.fetchTeamRankingData);
        return () => {
            var _a;
            (_a = ctx._communication) === null || _a === void 0 ? void 0 : _a.off('teamRankingRefresh', teamRankingStates.fetchTeamRankingData);
        };
    }, [teamRankingStates.fetchTeamRankingData]);
    if (TechStackUtil.isInEditor()) {
        return <View style={{
            alignItems: 'center'
        }}>
        <LImage borderRadius={0} style={{
            width: '750rpx',
            height: '1400rpx'
        }} source={{
            uri: 'https://img.meituan.net/makerjiulv/49ae8f494f5b0428926978921b80c575142000.png@format=webp&lossless=0@750w_1e_0c_1l'
        }}/>
      </View>;
    }
    return <Sensor once onAppear={() => lxReport(BID_MAP.COMP_MV)}>
      <TeamRanking onAnchorLayout={onTeamRankingAnchorLayout} lxReport={lxReport} teamRankingStates={teamRankingStates} invitePopupStates={invitePopupStates} tasksPopupStates={tasksPopupStates} drawChanceStatus={(_e = (_d = drawStates.drawInfo) === null || _d === void 0 ? void 0 : _d.extra) === null || _e === void 0 ? void 0 : _e.drawChanceStatus} rankingListLoadType={props.operationOptions.rankingListLoadType} rankingListPageSize={props.operationOptions.rankingListPageSize} tasksConfig={props.tasksConfig} onInviteMember={() => {
        var _a, _b, _c, _d, _e, _f;
        const groupId = (_c = (_b = (_a = teamRankingStates.teamRankingData) === null || _a === void 0 ? void 0 : _a.extra) === null || _b === void 0 ? void 0 : _b.teamInfo) === null || _c === void 0 ? void 0 : _c.groupId;
        const teamName = (_f = (_e = (_d = teamRankingStates.teamRankingData) === null || _d === void 0 ? void 0 : _d.extra) === null || _e === void 0 ? void 0 : _e.teamInfo) === null || _f === void 0 ? void 0 : _f.teamName;
        shareWXCard({
            params: {
                inviteType: InviteType.INVITE_MEMBER,
                taskId: props.inviteMemberTaskId,
                inviter: userId,
                groupId,
                teamName
            },
            shareConfig: Object.assign(Object.assign({}, props.shareConfig), { shareUrl: props.shareUrl })
        });
        lxReport(BID_MAP.SHARE_MC, {
            invite_source: 'invite_member'
        });
    }} onInviteCall={() => {
        var _a, _b, _c, _d, _e, _f;
        const groupId = (_c = (_b = (_a = teamRankingStates.teamRankingData) === null || _a === void 0 ? void 0 : _a.extra) === null || _b === void 0 ? void 0 : _b.teamInfo) === null || _c === void 0 ? void 0 : _c.groupId;
        const teamName = (_f = (_e = (_d = teamRankingStates.teamRankingData) === null || _d === void 0 ? void 0 : _d.extra) === null || _e === void 0 ? void 0 : _e.teamInfo) === null || _f === void 0 ? void 0 : _f.teamName;
        shareWXCard({
            params: {
                inviteType: InviteType.INVITE_CALL,
                taskId: props.inviteCallTaskId,
                inviter: userId,
                groupId,
                teamName
            },
            shareConfig: Object.assign(Object.assign({}, props.shareConfig), { shareUrl: props.shareUrl })
        });
        lxReport(BID_MAP.SHARE_MC, {
            invite_source: 'invite_call'
        });
    }} onInviteUnlock={rewardId => {
        shareWXCard({
            params: {
                inviteType: InviteType.INVITE_UNLOCK_FREE_CARD,
                taskId: props.inviteUnlockFreeCardTaskId,
                rewardId,
                inviter: userId
            },
            shareConfig: Object.assign(Object.assign({}, props.inviteUnlockFreeCardShareConfig), { shareUrl: props.shareUrl })
        });
        lxReport(BID_MAP.SHARE_MC, {
            invite_source: 'invite_unlock_free_card'
        });
    }} onShareFreeCard={() => {
        shareWXCard({
            shareConfig: Object.assign(Object.assign({}, props.shareConfig), { shareUrl: props.shareUrl })
        });
        lxReport(BID_MAP.SHARE_MC, {
            invite_source: 'free_card'
        });
    }} activityId={props.activityId} teamRankingId={props.teamRankingId} textConfig={props.textConfig} gotoOrderUrlInMt={gotoOrderUrlInMt} gotoOrderUrlInWX={gotoOrderUrlInWX} rankingListTime={props.operationOptions.rankingListTime} subscribeConfig={props.operationOptions.subscribeConfig} predictCityInfoData={predictCityInfoData} initRequest={initRequest} browseRecommendedHotelPoi={browseRecommendedHotelPoi} wishOptions={props.isIncludeWishTask ? props.wishOptions : []} isIncludeWishTask={props.isIncludeWishTask} autoJumpBrowsePageDuration={((_f = props.rdConfig) === null || _f === void 0 ? void 0 : _f.autoJumpBrowsePageDuration) || 0} isLaunchPoiDetail={Boolean((_g = props.rdConfig) === null || _g === void 0 ? void 0 : _g.wxLaunchPoiDetailUrlSchema)} children={props.children}/>
      <DrawModule x-if={(teamRankingStates === null || teamRankingStates === void 0 ? void 0 : teamRankingStates.inTeam) && !!drawStates.drawInfo} drawInfo={drawStates.drawInfo} onDraw={drawStates.doDraw} onDrawSuccess={drawStates.loadDrawInfo} reelImage={(_h = props.drawConfig) === null || _h === void 0 ? void 0 : _h.reelImage} rewardUuids={(_j = props.drawConfig) === null || _j === void 0 ? void 0 : _j.rewardUuids} lxReport={lxReport} teamRankingStatus={teamRankingStates.teamRankingStatus} onShare={() => {
        var _a, _b, _c, _d, _e, _f;
        const groupId = (_c = (_b = (_a = teamRankingStates.teamRankingData) === null || _a === void 0 ? void 0 : _a.extra) === null || _b === void 0 ? void 0 : _b.teamInfo) === null || _c === void 0 ? void 0 : _c.groupId;
        const teamName = (_f = (_e = (_d = teamRankingStates.teamRankingData) === null || _d === void 0 ? void 0 : _d.extra) === null || _e === void 0 ? void 0 : _e.teamInfo) === null || _f === void 0 ? void 0 : _f.teamName;
        shareWXCard({
            params: {
                inviteType: InviteType.INVITE_CALL,
                taskId: props.inviteCallTaskId,
                inviter: userId,
                groupId,
                teamName
            },
            shareConfig: Object.assign(Object.assign({}, props.shareConfig), { shareUrl: props.shareUrl })
        });
        lxReport(BID_MAP.SHARE_MC, {
            invite_source: 'invite_call'
        });
    }}/>
    </Sensor>;
};
export default memo(TeamRankingFree);
